import { FunctionComponent, memo, useEffect, useMemo, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { getWfWorkflows, updateWfWorkflows } from "../services/WfWorkflowsService";
import { CODE, RESPONSE_MESSAGE } from "../../utils/Constant";
import { toast } from "react-toastify";
import { WfTrackerField, WfWorkflowsNextStatuses, WfWorkflowsReq, WfWorkflowsRes } from "../models/WfWorkflows";
import wfAxiosGenerator from "../utils/WfAxiosGenerator";
import { localStorageItem } from '../../utils/LocalStorage'
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts'
import { convertTrackerFieldResponseToObject } from '../utils';
import { ConfirmDialog } from "../../component/ConfirmDialog";
import SpinnerOverlay from "../../component/loading/SpinnerOverlay";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import { WORKFLOW_TYPE } from "../Constant";
import clsx from "clsx";
interface WfAction {
  componentName: string,
  nameReq: string,
  cancel?: () => void
  submit: () => void,
  statusReq?: any
}
interface WfProps {
  tracker: string;
  objectId: string;
  additionalFunc?: (currStatusId?: string | undefined, codeButton?: string | undefined, listResponse?: any) => void;
  handleClick?: (props: WfAction) => void;
  additionalProps?: any;
  forceRender?: boolean;
  isContextMenu?: boolean;
  prefixFunction?: (
    currentStatusCode: string,
    wfCallbackFn: () => void | Promise<any>,
    cancel?: () => void,
    listResponse?: {}
  ) => void | Promise<any>;
  getTrackerField?: (fields: any) => void;
  componentName?: string;
  workflowList?: any;
  getCurrentWf?: (currStatus: any) => void;
  handleCloseMenu?: () => void;
}

const BASE_ENDPOINT = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL || "";

const WfButton: FunctionComponent<WfProps> = memo((wfProps: WfProps) => {
  const [workflowList, setWorkflowList] = useState<any>({}); 
  const [notification, setNotification] = useState<string>("")
  const [loadingButton, setLoadingButton] = useState<{ new: boolean, old: boolean }>({ new: false, old: false });
  const [loadingAdditionalButton, setLoadingAdditionalButton] = useState<{ [key: string]: boolean }>({});
  const ButtonComponent = wfProps?.isContextMenu ? "li" : Button;
  const showLoadingButton = (type: "new" | "old") => setLoadingButton(current => ({ ...current, [type]: true }));
  const hideLoadingButton = (type: "new" | "old") => setLoadingButton(current => ({ ...current, [type]: false }));
  const showLoadingAdditionalButton = (code: string) => setLoadingAdditionalButton(current => ({ ...current, [code]: true }));
  const hideLoadingAdditionalButton = (code: string) => setLoadingAdditionalButton(current => ({ ...current, [code]: false }));

  const updatePageData = useMemo(() => async () => {
    try {
      if(!wfProps?.workflowList) {
        let { data } = await getWfWorkflows(wfProps.tracker, wfProps.objectId);
        if (data?.code === CODE.SUCCESS) {
          wfProps?.getCurrentWf?.(data.data)
          setWorkflowList(data.data || []);
          wfProps.getTrackerField && wfProps.getTrackerField(
            convertTrackerFieldResponseToObject(data.data.wfTrackerFieldRestDtoList)
          );
          checkOpenContextMenu(data.data);
        }
      }
      else {
        setWorkflowList(wfProps?.workflowList);
        checkOpenContextMenu(wfProps.workflowList);
      }
    } catch (e) {
      toast.warning(RESPONSE_MESSAGE.ERROR);
    }
  }, [wfProps.tracker, wfProps.objectId]);

  useEffect(() => {
    updatePageData();
  }, [wfProps.tracker, wfProps.objectId, wfProps?.forceRender, updatePageData, wfProps?.workflowList]);

  const changeStatus = async (wfWorkflowsReq: WfWorkflowsReq | undefined, codeRequest?: string, listResponse?: any) => {
    if (!wfWorkflowsReq) return;
    try {
      let { data } = await updateWfWorkflows(wfProps.tracker, wfWorkflowsReq);

      if(data?.code === CODE.SUCCESS) {
        setWorkflowList(data.data || []);
        wfProps?.getCurrentWf?.(data.data)
        if (wfProps.additionalFunc) wfProps.additionalFunc(codeRequest, undefined, listResponse);
      }
      else {
        if (data?.message) {
          setNotification(data?.message || "");
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handleButtonClick = async (additionalButton: any, statusCode?: any) => {
    if (loadingAdditionalButton?.[additionalButton.code]) return;
    showLoadingAdditionalButton(additionalButton.code);
    try {
      const submit = () => {
        let response = additionalButton.handleClick(wfProps);
        wfProps.additionalFunc?.(statusCode?.curr, additionalButton.code, response);
        hideLoadingAdditionalButton(additionalButton.code);
      };

      if (additionalButton?.componentName && wfProps.handleClick) {
        wfProps.handleClick({
          componentName: additionalButton.componentName,
          nameReq: additionalButton.name,
          submit: submit,
          cancel: () => hideLoadingAdditionalButton(additionalButton.code),
          
        });
      } else {
        submit();
      }
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra!");
      hideLoadingAdditionalButton(additionalButton.code);
    }
  };

  const handleReq = async (statusReq: WfWorkflowsReq | undefined, codeReq: string, nameReq: string, componentName: string, type: "new" | "old", wfAxiosRequests: any, statusCode: any) => {
    if (loadingButton[type]) return;
    showLoadingButton(type);
    try {
      const actions =  wfAxiosRequests?.actions?.[codeReq];
      let listResponse: any = {}
      const submit = async (): Promise<void> => {
        const shouldExecutePrefixFirst = 
            wfAxiosRequests?.priority === "status" || !wfAxiosRequests?.priority;
    
        const executeActions = async (): Promise<any> => {
            if (!actions) return;
            for (const func of actions) {
                let data = await func(wfProps);
                if (data?.data?.data?.[0]?.errorMessage) {
                    !wfProps.handleClick && setNotification(data?.data?.data[0]?.errorMessage || "");
                    return data;
                }
                listResponse = { ...data?.data?.data, ...listResponse };
            }
        };
    
        const executePrefixFunction = async (): Promise<any> => {
          if (wfProps.prefixFunction) {
            wfProps.prefixFunction(
              statusCode.curr,
              async () => {
                await changeStatus(statusReq, codeReq, listResponse);
                hideLoadingButton(type);
              },
              () => hideLoadingButton(type),
              listResponse
            );
            return; 
          }
          await changeStatus(statusReq, codeReq, listResponse);
        };
    
        if (shouldExecutePrefixFirst) {
          await executePrefixFunction();
          const actionResult = await executeActions();
          if (actionResult) return actionResult;
        } else {
          const actionResult = await executeActions();
          if (actionResult) return actionResult;
          await executePrefixFunction()
        }
        
        hideLoadingButton(type);
    };
    
      if (componentName && wfProps.handleClick) {
        wfProps.handleClick({
          componentName: componentName,
          nameReq: nameReq,
          submit: submit,
          cancel: () => hideLoadingButton(type),
          statusReq
        });
      } else {
        await submit();
      }
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra!");
      hideLoadingButton(type);
    }
    finally {
      hideLoadingButton(type);
    }
  };

  const getWfAxiosRequests = (workflow: any) => {
    return wfAxiosGenerator(BASE_ENDPOINT, workflow.additionalConfiguration);
  }

  const checkOpenContextMenu = (workflowList: any) => {
    if (!workflowList?.nextStatuses?.length && wfProps?.isContextMenu) {
      wfProps?.handleCloseMenu?.();
    }
  };

  return (
    <>
      <>
        {workflowList?.additionalConfiguration && getWfAxiosRequests(workflowList) && getWfAxiosRequests(workflowList)?.axiosRequests && wfProps.objectId && getWfAxiosRequests(workflowList)?.axiosRequests?.map((additionalButton: any) => {       
          return (
            (!wfProps?.componentName || additionalButton?.componentNames?.find((componentName: string) => componentName === wfProps?.componentName) || !additionalButton?.componentNames) && 
            <Button className={`position-relative min-w-80 spaces mx-3 btn btn-fill ${loadingAdditionalButton?.[additionalButton.code] ? "cursor-wait" : ""}`} key={additionalButton.code} onClick={() => handleButtonClick(additionalButton)}>
              {loadingAdditionalButton?.[additionalButton.code] && <SpinnerOverlay />}
              {additionalButton.name}
            </Button>
          )
        })}
        {
          Array.isArray(workflowList?.nextStatuses)&& workflowList?.nextStatuses?.map((workflow: WfWorkflowsNextStatuses) => {
            let wfAxiosRequests = getWfAxiosRequests(workflow)
            let wfWorkflowsReqOld = { objectId: wfProps.objectId, status: workflow.oldStatusId }
            let config = workflow.additionalConfiguration ? JSON.parse(workflow.additionalConfiguration) : {};
            let wfWorkflowsReqNew = { objectId: wfProps.objectId, status: workflow.newStatusId }
            let statusCode = { old: workflow.oldStatusCode, curr: workflow.currStatusCode, new: workflow.newStatusCode }
            let newStatusName = workflow.newStatusName
            let oldStatusName = workflow.oldStatusName
            let componentConfig = wfAxiosRequests?.components?.find?.((component: any) => component?.name === wfProps?.componentName) 
            return componentConfig || !wfProps?.componentName || !wfAxiosRequests?.components ? (
				<>
					{wfAxiosRequests?.axiosRequests &&
						wfProps.objectId &&
						wfAxiosRequests.axiosRequests.map((additionalButton: any) => (
							<ButtonComponent
								className={`position-relative min-w-120 spaces mx-3 btn btn-fill ${
									loadingAdditionalButton?.[additionalButton.code]
										? 'cursor-wait'
										: ''
								}`}
								key={additionalButton.code}
								onClick={() => handleButtonClick(additionalButton, statusCode)}
							>
								{loadingAdditionalButton?.[additionalButton.code] && (
									<SpinnerOverlay />
								)}
								{additionalButton.name}
							</ButtonComponent>
						))}

					{workflow.oldStatusName && wfProps.objectId && (
						<ButtonComponent
							className={`position-relative min-w-120 spaces mx-3 btn btn-fill ${
								loadingButton.old ? 'cursor-wait' : ''
							}`}
							id="wf-old-status-button"
							onClick={() =>
								handleReq(
									wfWorkflowsReqOld,
									workflow.oldStatusCode,
									workflow.oldStatusName,
									config?.componentNameOldReq,
									'old',
									wfAxiosRequests,
									statusCode
								)
							}
						>
							{loadingButton.old && <SpinnerOverlay />}
							<span>
								{config?.oldStatusName ? config?.oldStatusName : oldStatusName}
							</span>
						</ButtonComponent>
					)}

					{workflow.newStatusName && wfProps.objectId && (
						<>
							{!componentConfig?.icon && !componentConfig?.iconText && (
								<ButtonComponent
									className={`position-relative min-w-120 spaces mx-3 btn btn-fill ${
										loadingButton.new ? 'cursor-wait' : ''
									}`}
									id="wf-new-status-button"
									onClick={() =>
										handleReq(
											wfWorkflowsReqNew,
											statusCode.new,
											workflow.newStatusName,
											wfAxiosRequests?.componentNameNewReq,
											'new',
											wfAxiosRequests,
											statusCode
										)
									}
								>
									{loadingButton.new && <SpinnerOverlay />}
									<span>
										{config?.newStatusName
											? config?.newStatusName
											: newStatusName}
									</span>
								</ButtonComponent>
							)}

							{componentConfig?.icon && !componentConfig?.iconText && (
								<CustomIconButton
									variant="edit"
									title={`${workflow?.newStatusName}`}
									onClick={() =>
										handleReq(
											wfWorkflowsReqNew,
											statusCode.new,
											workflow.newStatusName,
											wfAxiosRequests?.componentNameNewReq,
											'new',
											wfAxiosRequests,
											statusCode
										)
									}
								>
									<i className={componentConfig?.icon}></i>
								</CustomIconButton>
							)}

							{componentConfig?.iconText && (
								<ButtonComponent
									className={clsx(
										'position-relative p-1',
										'd-flex justify-content-between align-items-center',
										'border-bottom drop-list-item',
										{
											'cursor-wait': loadingButton.new,
										}
									)}
									id="wf-new-status-button"
									onClick={() =>
										handleReq(
											wfWorkflowsReqNew,
											statusCode.new,
											workflow.newStatusName,
											wfAxiosRequests?.componentNameNewReq,
											'new',
											wfAxiosRequests,
											statusCode
										)
									}
								>
									{loadingButton.new && <SpinnerOverlay />}
									<span className="fs-4 min-w-15px text-center">
										<i
											className={`fs-16 ${
												componentConfig.icon
											}`}
										/>
									</span>
									<div className="d-flex justify-content-between align-items-center w-100 ps-2">
										<span>{componentConfig.iconText}</span>
									</div>
								</ButtonComponent>
							)}
						</>
					)}
				</>
			) : (
				<></>
			);
          })
         }
      </>
      {
        <ConfirmDialog
          title="Thông báo"
          yes="OK"
          onYesClick={() => setNotification("")}
          message={notification}
          show={Boolean(notification)}
          onCloseClick={() => setNotification("")}
        />
      }
    </>
  );
});

export default WfButton;
